import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Testimonials from './pages/Testimonials';
import FAQPage from './pages/FAQ';
import Contact from './pages/Contact';
import SessionRequest from './pages/SessionRequest';
import GroupSpanking from './pages/GroupSpanking';
import RealStrapping from './pages/RealStrapping';
import Gallery from './pages/Gallery';
import Survey from './pages/Survey';
import SurveyResults from './pages/SurveyResults';
import { Toaster } from './components/ui/toaster';
import CookieBanner from './components/CookieBanner';
import { trackEvent } from './lib/analytics';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};

const EXCLUDED_ANALYTICS_PATHS = ['/survey-results'];

const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (EXCLUDED_ANALYTICS_PATHS.includes(pathname)) return undefined;
    const t = setTimeout(() => {
      trackEvent('page_view', {
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }, 100);
    return () => clearTimeout(t);
  }, [pathname, search]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/session-request" element={<SessionRequest />} />
            <Route path="/group-spanking" element={<GroupSpanking />} />
            <Route path="/real-strapping" element={<RealStrapping />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/survey" element={<Survey />} />
            <Route path="/survey-results" element={<SurveyResults />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
